import { formatarValorParaReal } from "src/app/utils/formata-valor";
import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";
import { CustomInputEditorNg2MoneyComponent } from "src/app/views/shared/custom-input-editor-ng2-money/custom-input-editor-ng2-money.component";
import { CustomInputEditorNg2PercentageComponent } from "src/app/views/shared/custom-input-editor-ng2-percentage/custom-input-editor-ng2-percentage.component";
import { CustomInputEditorNg2Component } from "src/app/views/shared/custom-input-editor-ng2/custom-input-editor-ng2/custom-input-editor-ng2.component";

export function obterConfiguracaoComissoesPrivadasValores() {
  let configuracaoComissoesPrivadasValores = _obterConfiguracaoComissoesBase();

  configuracaoComissoesPrivadasValores.columns = {
    tipoComissao: _obterColunaTiposComissoes,
    inicial: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2MoneyComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = formatarValorParaReal(value);
        return newValue;
      },
      title: "Valor Inicial",
      width: "23%",
      filter: false,
    },
    final: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2MoneyComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = formatarValorParaReal(value);
        return newValue;
      },
      title: "Valor Final",
      width: "23%",
      filter: false,
    },
    percentual: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2PercentageComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = value + "%";
        return newValue;
      },
      title: "Porcentagem",
      width: "20%",
      filter: false,
    },
  };

  return configuracaoComissoesPrivadasValores;
}

export function obterConfiguracaoComissoesPrivadasDias() {
  let configuracaoComissoesPrivadasDias = _obterConfiguracaoComissoesBase();

  configuracaoComissoesPrivadasDias.columns = {
    tipoComissao: _obterColunaTiposComissoesDias(),
    inicial: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2Component,
      },
      title: "Quantidade de dias inicial",
      width: "20%",
      filter: false,
    },
    final: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2Component,
      },
      title: "Quantidade de dias final",
      width: "20%",
      filter: false,
    },
    percentual: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2PercentageComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = value + "%";
        return newValue;
      },
      title: "Porcentagem",
      width: "20%",
      filter: false,
    },
  };

  return configuracaoComissoesPrivadasDias;
}

export function obterConfiguracaoComissoesPublicasDias() {
  let configuracaoComissoesPublicasDias = _obterConfiguracaoComissoesBase();

  configuracaoComissoesPublicasDias.columns = {
    tipoComissao: _obterColunaTiposComissoesDias(),
    inicial: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2Component,
      },
      title: "Quantidade de dias inicial",
      width: "20%",
      filter: false,
    },
    final: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2Component,
      },
      title: "Quantidade de dias final",
      width: "20%",
      filter: false,
    },
    percentual: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2PercentageComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = value + "%";
        return newValue;
      },
      title: "Porcentagem",
      width: "20%",
      filter: false,
    },
  };
}

export function obterConfiguracaoComissoesCobradorValores() {
  let configuracaoComissoesCobradorValores = _obterConfiguracaoComissoesBase();

  configuracaoComissoesCobradorValores.columns = {
    tipoCobrador: _obterColunaTiposComissoesCobrador(),
    percentual: {
      editor: {
        type: "custom",
        component: CustomInputEditorNg2PercentageComponent,
      },
      valuePrepareFunction: (value) => {
        var newValue = value + "%";
        return newValue;
      },
      title: "Porcentagem",
      width: "20%",
      filter: false,
    },
  };

  return configuracaoComissoesCobradorValores;
}

export function obterConfiguracaoHistoricoComissoes() {
  const configuracaoHistoricoComissoes = {
    hideSubHeader: true,
    actions: false,
    noDataMessage: "Não possui dado",

    add: {
      addButtonContent: "",
      createButtonContent: "",
      cancelButtonContent: "",
    },
    edit: {
      editButtonContent: "",
      saveButtonContent: "",
      cancelButtonContent: "",
    },
    delete: {
      deleteButtonContent: "",
    },
    pager: {
      display: false,
    },
    columns: {
      cpfCnpj: { title: "Cpf ou Cnpj", width: "25%", filter: false },
      nome: { title: "Nome", width: "25%", filter: false },
      email: { title: "Email", width: "25%", filter: false },
    },
    attr: {
      class: "table table-striped table-bordered",
    },
  };

  return configuracaoHistoricoComissoes;
}

function _obterConfiguracaoComissoesBase() {
  const base = obterConfiguracaoBase();
  //TODO: No objeto Action original, tinha a prop hideSubHeader: false. Não adicionei aqui, comparar com o cadastro
  // atual para ver o que faz essa prop. Se precisar, colocar ela na base, mas com parâmetro opcional

  return {
    ...base,
    add: obterConfiguracaoAdd(),
    edit: ObterConfiguracaoEditar(),
    delete: obterConfiguracaoDeletar(),
    columns: {},
  };
}

function _obterColunaTiposComissoes() {
  const filtroTiposComissoes = {
    type: "list",
    config: {
      selectText: "Selecione...",
      list: [
        { value: "Identificacao", title: "Identificação" },
        { value: "Pagamento", title: "Pagamento", selected: true },
      ],
    },
  };

  const colunaTiposComissoes = {
    width: "20%",
    editor: filtroTiposComissoes,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return colunaTiposComissoes;
}

function _obterColunaTiposComissoesDias() {
  const opcoesTiposComissoestipoDias = {
    type: "list",
    config: {
      title: "Tipo de comissão",
      selectText: "Selecione...",
      list: [
        { value: "Dias do Recebimento", title: "Dias do Recebimento" },
        { value: "Dias de vencido", title: "Dias de vencido" },
      ],
    },
  };
  var tiposComissoesColunatipoData = {
    title: "Tipo Data",
    width: "30%",
    editor: opcoesTiposComissoestipoDias,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return tiposComissoesColunatipoData;
}

function _obterColunaTiposComissoesCobrador() {
  const tiposComissoesCobrador = {
    type: "list",
    config: {
      selectText: "Selecione...",
      list: [
        { value: "Cobrador 1", title: "Cobrador 1 - Taxa + Nota" },
        {
          value: "Cobrador 2",
          title: "Cobrador 2 - Taxa Ou Nota",
          selected: true,
        },
      ],
    },
  };

  const colunaTiposComissoesCobrador = {
    width: "50%",
    editor: tiposComissoesCobrador,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return colunaTiposComissoesCobrador;
}
